var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrowserPage = function SvgBrowserPage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 6.5V22M4 10.75h1.5M4 14.25h1.5M4 17.75h1.5M12.75 10h6.5s.75 0 .75.75v7s0 .75-.75.75h-6.5s-.75 0-.75-.75v-7s0-.75.75-.75M12 14h8M16 14v4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 2h19.5s1.5 0 1.5 1.5v17s0 1.5-1.5 1.5H2.25s-1.5 0-1.5-1.5v-17S.75 2 2.25 2M.75 6.5h22.5"
  }))));
};
export default SvgBrowserPage;